import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudOff = function CloudOff(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M21.7003 16.1181A4.49 4.49 0 0 0 22 14.5c0-2.3436-1.7915-4.2687-4.0797-4.4806C17.4522 7.1721 14.9798 5 12 5a6.02 6.02 0 0 0-1.3005.1413m-3.412 2.1445a5.97 5.97 0 0 0-1.2078 2.7336C3.7915 10.2313 2 12.1564 2 14.5 2 16.9853 4.0147 19 6.5 19h11c.4561 0 .8963-.0678 1.3112-.194M3 3l18 18"
    })
  }));
};
export default CloudOff;